import React from "react";

class InstallationDetails extends React.Component {
		state = {
        dataset: []
    };
    componentDidMount(props)
   {
    let id = this.props.id;
        fetch(`http://localhost:8090/api/orders/${id}`)
            .then((response) => response.json())
            .then(data => {
              this.setState({ dataset: data });
            });
 }
	render(){
  return (
    <div>
	<div className="row">
	{this.state.dataset.map((machine,i) => (
<div key={i} className="col-sm-12">
<div className="card">
<div className="card-header">
<h5>Installation Details</h5>
</div>
<div className="card-body">
<form id="validation-form123" action="">
<div className="row">
<div className="col-md-4">
<div className="form-group">
 <label className="form-label">Manufacturer</label>
<input type="text" className="form-control" defaultValue={machine.MANUFACTURER} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">Sr. No</label>
<input type="number" className="form-control" defaultValue={machine.SR_N0} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">catalogue. No</label>
<input type="number" className="form-control" defaultValue={machine.CATALOGUE_NO} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">P.O.No</label>
<input type="number" className="form-control" defaultValue="" />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">P.O.Date</label>
<input type="Date" className="form-control" defaultValue={machine.PO_DATE} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">Cost Center</label>
<input type="number" className="form-control" defaultValue={machine.PURCHASE_COST} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">GRN.No</label>
<input type="text" className="form-control" defaultValue={machine.GRN_NO}/>
</div>
</div>
<div className="col-md-4">
<div className="form-group">
 <label className="form-label">Asset Code</label>
<input type="number" className="form-control" defaultValue={machine.AssetCode} />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">Installation Date</label>{machine.INSTALLATION_DATE}
<input type="datetime-local" className="form-control" />
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">Commissioning Date</label>
<input type="Date" className="form-control" defaultValue={machine.COMMISSIONING_DATE}/>
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">KW Load</label>
<input type="text" className="form-control" defaultValue={machine.KW_LOAD}/>
</div>
</div>
<div className="col-md-4">
<div className="form-group">
<label className="form-label">Model No</label>
<input type="text" className="form-control" />
</div>
</div>

</div>
<button type="submit" className="btn  btn-primary mx-1">Save</button>
<button type="submit" className="btn  btn-primary mx-1">close</button>
<button type="submit" className="btn  btn-primary mx-1">Import Details</button>
<button type="submit" className="btn  btn-primary mx-1 my-1">characteristics</button>
</form>
</div>
</div>
</div>
))}
</div>
    </div>
  );
	}
}

export default InstallationDetails;